/* Dependency Imports */
import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

/* Project Imports */
import Header from "./Header";
import { useProjectQuery } from "../../features/project/projectHooks";
import { useProjectSettingQuery } from "../../features/projectSetting/projectSettingHooks";
import { RegistrantNotificationProvider } from "../../context/RegistrantNotificationContext";
import { selectProject } from "../../features/project/projectSlice";
import { selectCrmProjectId } from "../../features/projectSetting/projectSettingSlice";

const Layout = () => {
  /* Redux */
  const { projectid } = useParams();
  const project = useSelector(selectProject);
  const projectSetting = useSelector(selectCrmProjectId);

  useProjectQuery(projectid!, project?._id!);
  useProjectSettingQuery(projectid!, project?._id!, projectSetting);

  /* States */

  /* Queries/Mutations */

  /* Functions */

  return (
    <>
      <RegistrantNotificationProvider>
        <Header />
        <Box
          sx={{
            p: 3,
            "@media (max-width: 1300px)": {
              minHeight: "calc(100vh - -80px)",
            },
            minHeight: "calc(100vh - 80px)",
            backgroundColor: "#e5e5e5",
          }}
        >
          <Outlet />
        </Box>
      </RegistrantNotificationProvider>
    </>
  );
};

/* Types */

/* GQL */

export default Layout;
